define('modules/home/main/views/history.date.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette"
], function(Prospector,$, _,Backbone,
            Marionette) {
    var HistoryDateView = Marionette.ItemView.extend({
        template: _.template(''),
        className:"activityDateHolder",
        initialize: function(options){
            this.identityDate = options.identityDate;
        },
        onRender:function(){
            var date = this.identityDate.split(" ")[0];
            var d = new Date(date);
            var parts = d.toDateString().split(" ");
            $(this.el).append(
                parts[0] + ", "
                + parts[1] + " "
                + parts[2] + ", "
                + parts[3]);
        }
    });
    return HistoryDateView;
});
